import { useEffect } from "react"

import api from "../../api"

let timeout = 0
let popup = null

export const loginWithGoogle = async ({ finishLogin, setShowAlert, setLoading }) => {
    const res = await api.get(
        "/api/oauth/embedding/?" +
        new URLSearchParams({
            provider: "GOOGLE_SSO",
            scopes: "openid email profile",
            redirect_url: "https://accounts.google.com/o/oauth2/v2/auth"
        })
    )

    popup = window.open(
        res.data,
        "_blank",
        "width=500,height=750,noopener=false"
    )

    let stopped = false

    const poll = async () => {

        if (stopped)
            return
        
        try {
            const res = await api.get("/api/oauth/check_status/")

            if (res.data.status === "SUCCESS") {
                stopped = true
                setLoading(true)
                await finishLogin(res.data.login_data, setShowAlert, setLoading)
                setLoading(false)
                return
            }

            if (res.data.status === "ERROR") {
                stopped = true
                if (res.data.message === "No active account found with the given credentials.") {
                    setShowAlert("Nenhuma conta ativa encontrada com o email informado.")
                }
                if (res.data.message === "SSO not enabled for enterprise.") {
                    setShowAlert("Entrar com provedor externo não está ativo para a sua empresa.")
                }
                return
            }
        } catch (err) {
            console.error(err)
        }

        clearTimeout(timeout)
        timeout = setTimeout(poll, 2000)
    }

    poll()
}

export const loginWithEntraID = async ({ vanityUrl, finishLogin, setShowAlert, setLoading }) => {
    const res = await api.get(
        "/api/oauth/embedding/?" +
        new URLSearchParams({
            provider: "MICROSOFT_ENTRA_SSO",
            vanity_url: vanityUrl,
            scopes: "openid profile email",
        })
    )

    const popup = window.open(
        res.data,
        "_blank",
        "width=500,height=750,noopener=false"
    )

    let stopped = false

    const poll = async () => {

        if (stopped)
            return

        try {
            const res = await api.get("/api/oauth/check_status/")

            if (res.data.status === "SUCCESS") {
                stopped = true
                setLoading(true)
                await finishLogin(res.data.login_data, setShowAlert, setLoading)
                setLoading(false)
                return
            }

            if (res.data.status === "ERROR") {
                stopped = true
                if (res.data.message === "No active account found with the given credentials.") {
                    setShowAlert("Nenhuma conta ativa encontrada com o email informado.")
                } else if (res.data.message === "Account does not belong to this organization.") {
                    setShowAlert("Esta conta não pertence à sua organização.")
                } else {
                    setShowAlert(res.data.message || "Erro ao autenticar com o Entra ID.")
                }
                return
            }
        } catch (err) {
            console.error(err)
        }

        clearTimeout(timeout)
        timeout = setTimeout(poll, 2000)
    }

    poll()
}

export const loginWithMicrosoft = async ({ finishLogin, setShowAlert, setLoading }) => {
    const res = await api.get(
        "/api/oauth/embedding/?" +
        new URLSearchParams({
            provider: "MICROSOFT_SSO",
            scopes: "openid profile email",
            redirect_url: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
        })
    )

    popup = window.open(
        res.data,
        "_blank",
        "width=500,height=750,noopener=false"
    )

    let stopped = false

    const poll = async () => {

        if (stopped)
            return
        
        try {
            const res = await api.get("/api/oauth/check_status/")

            if (res.data.status === "SUCCESS") {
                stopped = true
                setLoading(true)
                await finishLogin(res.data.login_data, setShowAlert, setLoading)
                setLoading(false)
                return
            }

            if (res.data.status === "ERROR") {
                stopped = true
                if (res.data.message === "No active account found with the given credentials.") {
                    setShowAlert("Nenhuma conta ativa encontrada com o email informado.")
                }
                if (res.data.message === "SSO not enabled for enterprise.") {
                    setShowAlert("Entrar com provedor externo não está ativo para a sua empresa.")
                }
                return
            }
        } catch (err) {
            console.error(err)
        }

        clearTimeout(timeout)
        timeout = setTimeout(poll, 2000)
    }

    poll()
}
